import Grid from '@mui/material/Grid';
import type { SxProps, Theme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup, { type ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';
import { ToggleButtonGroupDesignSystemScope } from '@openx/components-core/lib/ToggleButtonGroupField/ToggleButtonGroupDesignSystemScope.tsx';
import type { JSX } from 'react';
import { StyledSwitchGroupTitle } from './Switch.styled.tsx';

export type SwitchProps = {
  switchState: boolean;
  onSwitchChange: ToggleButtonGroupProps['onChange'];
  switchOffLabel: string;
  switchOnLabel: string;
  groupTitle?: string;
  disabled?: boolean;
  customSx?: SxProps<Theme>;
};

export const Switch = ({
  switchState,
  onSwitchChange,
  switchOffLabel,
  switchOnLabel,
  groupTitle,
  disabled,
  customSx,
}: SwitchProps): JSX.Element => {
  return (
    <Grid
      data-test="switch-container"
      container
      sx={{
        alignItems: 'center',
        marginTop: theme => theme.spacing(1),
        ...customSx,
      }}
    >
      <ToggleButtonGroupDesignSystemScope>
        <ToggleButtonGroup
          exclusive
          onChange={onSwitchChange}
          value={switchState}
          disabled={disabled}
          data-test="toggle-button-group"
        >
          <ToggleButton data-test="switch-one" id={switchOffLabel} value={false}>
            {switchOffLabel}
          </ToggleButton>
          <ToggleButton data-test="switch-two" id={switchOnLabel} value={true}>
            {switchOnLabel}
          </ToggleButton>
        </ToggleButtonGroup>
      </ToggleButtonGroupDesignSystemScope>
      {groupTitle && <StyledSwitchGroupTitle data-test="switch-group-title">{groupTitle}</StyledSwitchGroupTitle>}
    </Grid>
  );
};
